import { Globals } from '@bwoty-web/ui-kit';
import { hydrateRoot } from 'react-dom/client';
import CruiseShipDescriptionView from '../shared/views/cruiseShipDescription/cruiseShipDescriptionView';

const initialStateCruiseShipDescription =
  window.__INITIAL_STATE_CRUISE_SHIP_DESCRIPTION__;
delete window.__INITIAL_STATE_CRUISE_SHIP_DESCRIPTION__;
const cruiseShipDescriptionRoot = document.getElementById(
  'cruise-ship-description-view',
);

if (cruiseShipDescriptionRoot) {
  const { cruiseShipContent, labels, siteSettings, legacyMode } =
    initialStateCruiseShipDescription;
  hydrateRoot(
    cruiseShipDescriptionRoot,
    <Globals legacyMode={legacyMode} siteId={siteSettings?.siteId}>
      <CruiseShipDescriptionView
        cruiseShipContent={cruiseShipContent}
        labels={labels}
      />
    </Globals>,
  );
}
